import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import TodayIcon from '@mui/icons-material/Today';

export default function TopicDisplay({ topic }) {
  const { t } = useTranslation();

  if (!topic) return null;

  const formattedDate = topic.date
    ? new Date(topic.date).toLocaleDateString(undefined, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : '';

  return (
    <Card
      sx={{
        width: '100%',
        background: 'linear-gradient(135deg, #e8f0fe 0%, #ede7f6 100%)',
        border: '1px solid rgba(25,118,210,0.2)',
        animation: 'fadeInDown 0.4s ease-out',
        '@keyframes fadeInDown': {
          from: { opacity: 0, transform: 'translateY(-16px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      <CardContent sx={{ textAlign: 'center', py: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
          <TodayIcon color="primary" fontSize="small" />
          <Typography variant="overline" color="text.secondary" fontWeight={600}>
            {t('home.topicLabel')}
          </Typography>
        </Box>

        <Typography
          variant="h2"
          fontWeight={800}
          color="primary"
          sx={{
            textTransform: 'uppercase',
            letterSpacing: 2,
            fontSize: { xs: '2rem', sm: '3rem' },
            mb: 2,
            textShadow: '0 2px 8px rgba(25,118,210,0.2)',
          }}
        >
          {topic.topic}
        </Typography>

        {topic.suggestedByUserName && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {t('home.suggestedBy', { name: topic.suggestedByUserName })}
          </Typography>
        )}

        {formattedDate && (
          <Chip
            label={formattedDate}
            size="small"
            variant="outlined"
            color="primary"
            icon={<TodayIcon />}
          />
        )}
      </CardContent>
    </Card>
  );
}
